import React from 'react'
import ActiveLoansTable from './Components/ActiveLoansTable';
import { LoansCardData } from './Components/LoansCardData';

const Loans = () => {

    return (
        <div>
            {/* x---------------------------------x Loans Card Overview section x---------------------------------x */}
            <div className="row g-sm-3 g-1">
                {LoansCardData.map((data, index) => {
                    return (
                        // x---------------------------------x Loans Cards x---------------------------------x 
                        <div className="col-xl-3 col-sm-6 col-12" key={index} >
                            <div className="card border-0 bg-transparent h-100">
                                <div className="card-body rounded-4 bg-white">
                                    <div className="d-flex">
                                        <div
                                            className={`card-img avatar lg no-thumbnail rounded-circle me-3 ${data.icon_bg}`}>
                                            {data.icon}
                                        </div>
                                        <div className="card-text">
                                            <p className="text-secondary opacity-50 fs-6 fw-normal  m-0">{data.title}</p>
                                            <p className="text-dark fs-6 fw-semibold  m-0">{data.amount}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )
                })}
            </div>

            {/* x---------------------------------x Active Loans Overview section x---------------------------------x */}
            <div className="row g-sm-3 g-1 mt-1 mt-sm-3">
                {/* x---------------------------------x Active Loans x---------------------------------x */}
                <div className="col-sm-12">
                    <div className="card border-0 bg-transparent h-100">
                        <div className="card-header justify-content-between">
                            <h3 className="text-dark fs-5 fw-semibold">Active Loans Overview</h3>
                        </div>
                        <div className="card-body rounded-4 mb-3 mb-sm-0 bg-white">
                            <ActiveLoansTable />
                        </div>
                    </div>
                </div>
            </div>

            {/* x---------------------------------x Repay POP UP model x---------------------------------x */}
            <div className="modal fade" id="exampleModal" tabIndex="-1" aria-labelledby="exampleModalLabel"
                aria-hidden="true">
                <div className="modal-dialog">
                    <div className="modal-content text-dark">
                        <div className="modal-header">
                            <h1 className="modal-title fs-5" id="exampleModalLabel">Repay</h1>
                            <button type="button" className="btn-close" data-bs-dismiss="modal"
                                aria-label="Close"></button>
                        </div>
                        <div className="modal-body">
                            <form>
                                <div className="mb-3">
                                    <label htmlFor="cardHolderName" className="form-label">Card Holder's
                                        Name</label>
                                    <input type="text" className="form-control" id="cardHolderName"
                                        placeholder="John Doe" required="" />
                                </div>
                                <div className="mb-3">
                                    <label htmlFor="cardNumber" className="form-label">Card Number</label>
                                    <input type="text" className="form-control" id="cardNumber"
                                        placeholder="1234 5678 9012 3456" required="" />
                                </div>
                                <div className="mb-3">
                                    <label htmlFor="cardNumber" className="form-label">Amount</label>
                                    <input type="text" className="form-control" id="cardNumber" placeholder="2000"
                                        required="" />
                                </div>
                                <div className="row">
                                    <div className="col-md-6 mb-3">
                                        <label htmlFor="expiryDate" className="form-label">Expiry Date</label>
                                        <input type="text" className="form-control" id="expiryDate"
                                            placeholder="MM/YY" required="" />
                                    </div>
                                    <div className="col-md-6 mb-3">
                                        <label htmlFor="cvv" className="form-label">CVV</label>
                                        <input type="text" className="form-control" id="cvv" placeholder="123"
                                            required="" />
                                    </div>
                                </div>
                                <div className="d-grid">
                                    <button type="submit" className="btn btn-primary">Pay Now</button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div >
    )
}

export default Loans;